<template>
  <div>
    <v-card
      color="transparent"
      flat
    >
      <v-card-text>
        <elil-lion-head/>
      </v-card-text>
    </v-card>
    <v-card
      :class="gameResult"
      class="mb-5"
      color="secondary"
    >
      <v-card-text>
        <v-layout
          row
          wrap
          justify-center>
          <v-flex
            class="headline winner home-team"
            xs4
            py-4
            text-xs-center>
            {{ latestMatch.home }}
          </v-flex>
          <v-flex
            class="display-2 game-result"
            xs4
            py-2
            text-xs-center
            white--text>
            {{ latestMatch.goalsHome }}:{{ latestMatch.goalsGuest }}
            <div class="game-date pt-1">
              {{ latestMatch.date | moment('DD.MM.YYYY') }}
            </div>
          </v-flex>
          <v-flex
            class="headline looser guest-team"
            xs4
            py-4
            text-xs-center>
            {{ latestMatch.guest }}
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import ElilLionHead from './ElilLionHead';

export default {
  name: 'ElilHome',
  components: {
    ElilLionHead,
    FontAwesomeIcon,
  },
  computed: {
    latestMatch() {
      return this.$store.getters.latestMatch;
    },
    gameResult() {
      const match = this.latestMatch;
      if (match.goalsHome > match.goalsGuest) {
        return 'home-won';
      }
      if (match.goalsHome < match.goalsGuest) {
        return 'guest-won';
      }
      return 'draw';
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .result {
    font-size: 1.2em;
    font-weight: 900;
  }

  .headline {
    overflow: hidden;
  }

  .game-date {
    font-size: 12px;
    line-height: 12px;
  }

  .home-won {
    .home-team {
      color: #deffde;
    }
    .guest-team {
      color: #ffdede;
    }
  }

  .guest-won {
    .home-team {
      color: #ffdede;
    }
    .guest-team {
      color: #deffde;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ElilHome.vue